import customModal from "../customModal/customModal.vue";

export default {
    name: "FieldRulePopup",
    components: { customModal },

    emits: ['close-popup'],

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        closePopup() {
            this.$emit("close-popup");
        }
    }
}